import React from 'react';
import { Countdown } from '../hooks/useCountdown';
type Size = 'sm' | 'lg';
type CountdownTimerProps = {
  countdown: Countdown;
  label: string;
  size?: Size;
  className?: string;
};
const boxSize: Record<Size, string> = {
  sm: 'text-2xl px-3 py-1.5 min-w-[3rem]',
  lg: 'text-4xl sm:text-5xl px-4 py-2.5 min-w-[4.5rem]'
};
export function CountdownTimer({
  countdown,
  label,
  size = 'sm',
  className = ''
}: CountdownTimerProps) {
  const units: Array<[string, string]> = [[countdown.hours, 'HRS'], [countdown.minutes, 'MIN'], [countdown.seconds, 'SEG']];
  return <div className={className} data-id="element-1" data-mp="1ach9ef4ge23j">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/50" data-id="element-2" data-mp="1adsc0bm5x3t2">{label}</p>
      <div className="mt-2 flex items-start gap-2" role="timer" aria-live="off" data-id="element-3" data-mp="15ephhl3t6fzc">
        {units.map(([value, unit], i) => <React.Fragment key={unit} data-id="element-4" data-mp="34pz02b05nf2s" data-mpi={i}>
            {i > 0 && <span className={`font-display font-black text-flame/60 ${size === 'lg' ? 'text-4xl sm:text-5xl pt-1.5' : 'text-2xl pt-0.5'}`} aria-hidden="true" data-id="element-5" data-mp="2zrfa7zifxj55">
                :
              </span>}
            <div className="flex flex-col items-center" data-id="element-6" data-mp="1gxf696lk4ld7">
              <div className={`rounded-lg border border-white/10 bg-ink-800 text-center font-display font-black tabular-nums text-white ${boxSize[size]}`} data-id="element-7" data-mp="123slypqvzpt1">
                {value}
              </div>
              <span className="mt-1 text-[10px] font-semibold tracking-[0.18em] text-white/40" data-id="element-8" data-mp="1utit2eu3prfn">{unit}</span>
            </div>
          </React.Fragment>)}
      </div>
      <span className="sr-only" data-id="element-9" data-mp="1l0tvmnvdye3b">
        {countdown.expired ? 'La oferta está por expirar' : `Quedan ${countdown.hours} horas, ${countdown.minutes} minutos y ${countdown.seconds} segundos`}
      </span>
    </div>;
}